module.exports = __webpack_public_path__ + "static/media/under-maple-canopy.f712d2a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/under-maple-canopy.jpg
// module id = 120
// module chunks = 0